import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";
import { Button } from "zina-dogi-react";
import { Formik, Form, Field } from "formik";
import "./tcc_update_modal.scss";

export default class TCCUpdateModal extends Component {
    constructor(props) {
        super(props);
        this.data = null;
        this.state = { modal: false };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
        return (
            <div>
                <Button color="primary" onClick={this.toggle} icon="wallet" type="button">
                    Finance Data
                </Button>
                <Modal isOpen={this.state.modal} size="lg">
                    <ModalHeader>Finance Data</ModalHeader>
                    <ModalBody>
                        <Formik
                            className="tcc-update-modal"
                            initialValues={{
                                sap_top_wbs: "",
                                for_offer_number_created_in_csp: "",
                                quantity_contract_number: "",
                                customer_payment_terms: "",
                                incoterms: "",
                                incoterms_code: "",
                                payment_terms_code: "",
                                sales_order_billing_plan: "",
                                sap_customer_name: "",
                                sap_down_payment_contract_number: ""
                            }}
                            onSubmit={(values, cmp) => {
                                this.props.onSubmit(values, cmp);
                                cmp.resetForm();
                                cmp.setSubmitting(false);
                                this.toggle();
                            }}
                        >
                            {cpm => (
                                <Form className="form">
                                    <div className="fields">
                                        <Row>
                                            <Col>
                                                <div className="form-group">
                                                    <label>SAP Top WBS</label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        name="sap_top_wbs"
                                                        autoComplete="off"
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="form-group">
                                                    <label>For offer number created in CSP</label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        name="for_offer_number_created_in_csp"
                                                        autoComplete="off"
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="form-group">
                                                    <label>Quantity Contract Number</label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        name="quantity_contract_number"
                                                        autoComplete="off"
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <div className="form-group">
                                                    <label>Customer Payment Terms</label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        name="customer_payment_terms"
                                                        autoComplete="off"
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="form-group">
                                                    <label>Incoterms</label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        name="incoterms"
                                                        autoComplete="off"
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="form-group">
                                                    <label>Incoterms Code</label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        name="incoterms_code"
                                                        autoComplete="off"
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <div className="form-group">
                                                    <label>Payment Terms Code</label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        name="payment_terms_code"
                                                        autoComplete="off"
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="form-group">
                                                    <label>Sales Order Billing Plan</label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        name="sales_order_billing_plan"
                                                        autoComplete="off"
                                                    />
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="form-group">
                                                    <label>Sap Customer Name</label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        name="sap_customer_name"
                                                        autoComplete="off"
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md="4">
                                                <div className="form-group">
                                                    <label>Sap Down Payment Contract Number</label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        name="sap_down_payment_contract_number"
                                                        autoComplete="off"
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="controls">
                                        <Button type="submit" color="primary" style={{ width: "150px" }}>
                                            Save
                                        </Button>
                                        <Button
                                            className="btn-danger"
                                            onClick={this.toggle}
                                            type="button"
                                            name="Close"
                                            style={{ width: "150px" }}
                                        >
                                            Close
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}
